import { listPlaidCreditCardTransactionsByAccountNumberByDate } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchPlaidCreditCardTransactionByAccountNumberByDate = async (lastFour, startDate, limit = 450) => {
  try {
    const gqlParams = {
      accountNumber: lastFour,
      date: { ge: startDate },
      sortDirection: 'DESC',
      limit,
    };

    console.info(' 🤖🤖🤖 GraphQL Params:', lastFour, gqlParams);

    const response = await client.graphql({
      query: listPlaidCreditCardTransactionsByAccountNumberByDate,
      variables: gqlParams,
    });

    console.info(' 🤖🤖🤖 GraphQL Response:', lastFour, response);

    if (!response || !response.data || !response.data.capOneTransactionsByCardByDate) {
      console.warn(`No data returned for card ending in ${lastFour}`);
      return null;
    }

    const results = response.data.capOneTransactionsByCardByDate.items;

    console.warn('query results', results);

    if (!Array.isArray(results) || results.length === 0) {
      console.warn(`No transactions found for card ending in ${lastFour}`);
      return null;
    }

    // TEMPORARY FIX

    const xdedupedMap = new Map();

    results.forEach(txn => {
      if (txn.date <= "2025-07-01") return;
      // const key = `${txn.accountNumber}-${txn.amount}-${txn.date}-${txn.merchantEntityId}`;
      const key = `${txn.accountNumber}-${txn.amount}-${txn.date}-${txn.merchantEntityId}-${txn.transactionId}`;
      const existing = xdedupedMap.get(key);

      const hasReceipt = !!txn.capitalOneCreditCardTransactionReceiptId;
      const existingHasReceipt = existing ? !!existing.capitalOneCreditCardTransactionReceiptId : false;

      // If no existing, or current one has receipt and existing doesn't, replace it
      if (!existing || (!existingHasReceipt && hasReceipt)) {
        xdedupedMap.set(key, txn);
      }
    });

    const xfilteredResults = Array.from(xdedupedMap.values());

    console.info(' ✅ X Filtered (deduplicated) transactions:', xfilteredResults);

    // TEMPORARY FIX 

    // 🔥 Duplicate filter logic here
    // const dedupedMap = new Map();

    // results.forEach(txn => {
    //   const key = `${txn.accountNumber}-${txn.amount}-${txn.date}-${txn.merchantEntityId}`;
    //   // const key = `${txn.accountNumber}-${txn.amount}-${txn.date}-${txn.merchantEntityId}-${txn.transactionId}`;
    //   const existing = dedupedMap.get(key);

    //   const hasReceipt = !!txn.capitalOneCreditCardTransactionReceiptId;
    //   const existingHasReceipt = existing ? !!existing.capitalOneCreditCardTransactionReceiptId : false;

    //   // If no existing, or current one has receipt and existing doesn't, replace it
    //   if (!existing || (!existingHasReceipt && hasReceipt)) {
    //     dedupedMap.set(key, txn);
    //   }
    // });

    // const filteredResults = Array.from(dedupedMap.values());

    // console.info(' ✅ Filtered (deduplicated) transactions:', filteredResults);

    //return filteredResults; // For now, return the original set
    return xfilteredResults; // Return the xdeduped results for now
  } catch (err) {
    console.error('Error in fetchPlaidCreditCardTransactionByAccountNumberByDate:', err);
    return null;
  }
};

fetchPlaidCreditCardTransactionByAccountNumberByDate.propTypes = {
  lastFour: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  limit: PropTypes.number,
};
